import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { X, ClipboardCheck } from "lucide-react";
import { NeuButton, NeuInput } from "../../components/neu/Neu";
import { NeuDropdown } from "../../components/data/NeuDropdown";
import { listWarehouses } from "../../api/warehouse";
import { createCount } from "../../api/counts";
import { localName } from "../../lib/localName";

// شاشة بدء الجرد (شاشة كاملة): ترويسة خضراء ثابتة + جسم قابل للتمرير.
export const CountForm = ({ branchId, onClose, onCreated }) => {
  const { t } = useTranslation();
  const [ws, setWs] = useState([]);
  const [wh, setWh] = useState("");
  const [countType, setCountType] = useState("full");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!branchId) return;
    listWarehouses(branchId).then((d) => {
      setWs(d.items || []); setWh((d.items || [])[0]?.warehouse_id || "");
    });
  }, [branchId]);

  const save = async () => {
    if (!wh) return;
    setBusy(true);
    try {
      const doc = await createCount({ branch_id: branchId, warehouse_id: wh,
        count_type: countType, reason: reason || null });
      toast.success(t("warehouse.count.created", { number: doc.number }));
      onCreated(doc);
    } catch (e) {
      toast.error(e?.response?.data?.detail?.code || t("errors.generic"));
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[80] flex flex-col bg-background" data-testid="count-form">
      <div className="flex flex-shrink-0 items-center justify-between gap-3 bg-gradient-to-r from-teal-600 to-cyan-600 px-6 pb-4 pt-[max(1rem,calc(env(safe-area-inset-top)+0.75rem))] text-white shadow-xl">
        <div className="flex items-center gap-3">
          <ClipboardCheck className="h-6 w-6" />
          <p className="text-lg font-black sm:text-xl">{t("warehouse.count.newTitle")}</p>
        </div>
        <button onClick={onClose} data-testid="cnt-close"
                className="rounded-full bg-white/15 p-2 transition hover:bg-white/25">
          <X className="h-6 w-6" /></button>
      </div>
      <div className="flex-1 overflow-y-auto px-4 py-6 sm:px-8">
        <div className="mx-auto grid max-w-3xl gap-4">
          <div className="rounded-2xl bg-teal-500/10 p-4 text-xs text-teal-800 dark:text-teal-200">
            {t("warehouse.count.newHint")}
          </div>
          <div><p className="label-xs mb-2">{t("warehouse.count.warehouse")} *</p>
            <NeuDropdown testid="cnt-wh" value={wh} onChange={setWh}
                         placeholder={t("warehouse.count.pickWh")}
                         options={ws.map((w) => ({ value: w.warehouse_id,
                           label: `${localName(w)} — ${w.keeper_name || t("warehouse.tr.noKeeper")}` }))} /></div>
          <div><p className="label-xs mb-2">{t("warehouse.count.type")} *</p>
            <NeuDropdown testid="cnt-type" value={countType} onChange={setCountType}
                         options={[{ value: "full", label: t("warehouse.count.types.full") },
                                   { value: "cycle", label: t("warehouse.count.types.cycle") }]} /></div>
          <div><p className="label-xs mb-2">{t("warehouse.count.reason")}</p>
            <NeuInput data-testid="cnt-reason" value={reason}
                      placeholder={t("warehouse.count.reasonPlaceholder")}
                      onChange={(e) => setReason(e.target.value)} /></div>
          <div className="flex justify-end border-t border-border/40 pt-4">
            <NeuButton variant="primary" data-testid="cnt-save" disabled={!wh || busy} onClick={save}
                       className="bg-teal-500 text-white hover:bg-teal-600">
              <ClipboardCheck className="inline h-4 w-4" /> {t("warehouse.count.start")}</NeuButton>
          </div>
        </div>
      </div>
    </div>
  );
};
